import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 17,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#F3F3F3",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function CatContributionBar({ value, color }: { value: number; color: string }) {
  return (
    <BorderLinearProgress
      variant="determinate"
      value={value}
      sx={{
        [`& .${linearProgressClasses.bar}`]: {
          backgroundColor: color,
        },
      }}
    />
  );
}
